define('entities/mbanaresgrs',[
  'app',
  'backbone',
  'settings',
  'jquery',
  'underscore'
], function(
  App,
  Backbone,
  Settings,
  $,
  _
) {
  'use strict';

  var MbAnaResGr = Backbone.Model.extend({
    fetch: function() {
      this.url = Settings.url('compuzz', 'v2/mbanaresgrs/' + this.get('secId'));

      return Backbone.Model.prototype.fetch.call(this);
    },
    defaults: {
      code: '',
      name: '',
      description: ''
    },
    idAttribute: 'secId',
    getImageUid:function() {},

    postUrl: function () {
      return Settings.url('compuzz', 'v2/mbanaresgrs');
    },

    save: function() {
      this.url = this.postUrl();
      return Backbone.Model.prototype.save.call(this);
    }
  });

  var MbAnaResGrCollection = Backbone.Collection.extend({
    url: function() {
      return Settings.url('compuzz', 'v2/mbanaresgrs');
    },
    model: MbAnaResGr
  });

  var API = {

    getMbAnaResGrCollectionUrl: function() {
      new MbAnaResGrCollection();
      var params = {};
      return Settings.url('compuzz', 'v2/mbanaresgrs', params);
    },

    getAllMbAnaResGrs: function(params) {
      var url = Settings.url('compuzz', 'v2/mbanaresgrs', params),
          defer = $.Deferred();

      $.ajax({
        method: 'get',
        url: url,
        success: function(items) {
          var list = [];
          _.each(items, function(item){
            list.push(item.secId);
          });
          defer.resolve(list);
        }
      });

      return defer.promise();
    },

    getMbAnaResGrCountUrl: function() {
      var params = '';
      return 'v2/mbanaresgrs/rowCount' + params;
    },

    deleteMbAnaResGr: function(secId){
      var url = Settings.url('compuzz', 'v2/mbanaresgrs/'+secId),
          defer = $.Deferred();

      $.ajax({
        type: 'DELETE',
        url: url,
        success: function (data) {
          defer.resolve(data);
        }
      });

      return defer.promise();
    }
  };

  App.reqres.setHandler('mbanaresgr:get-collection-url', function() {
      return API.getMbAnaResGrCollectionUrl();
  });

  App.reqres.setHandler('mbanaresgr:get-collection-to-page', function(params) {
      return API.getAllMbAnaResGrs(params);
  });

  App.reqres.setHandler('mbanaresgr:get-count-url', function() {
    return API.getMbAnaResGrCountUrl();
  });

  App.reqres.setHandler('mbanaresgr:model', function(itemJSON) {
    return new MbAnaResGr(itemJSON);
  });

  App.reqres.setHandler('mbanaresgr:delete', function(secId) {
    return API.deleteMbAnaResGr(secId);
  });
});
